import React from 'react';
import Cookies from 'js-cookie';
import { Button, FormGroup, Input, Col, Row, TabContent, TabPane, Nav, NavItem, NavLink, Label, Container, Alert } from 'reactstrap';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import api from '../../api';
import Select from 'react-select';

import SiteTextInput from 'components/SiteTextInput';
import SiteDropdownInput from 'components/SiteDropdownInput';
import LocationMetricsView from 'components/LocationMetricsView';
// import SiteFinancialProjection from 'components/SiteFinancialProjection';
import LocationContactView from 'components/LocationContactView';

import PhotoPlaceholder from 'resources/images/photo_placeholder.jpg';

import constants from '../../constants';
import './index.css';

const POPULATION_FIELDS = [
    {
        sectionTitle: 'Dân số văn phòng',
        fields: [
            {
                valueFieldName: 'population_office_inbuilding',
                crFieldName: 'population_office_inbuilding_conversion_rate',
            },
            {
                valueFieldName: 'population_office_300m',
                crFieldName: 'population_office_300m_conversion_rate',
            },
            {
                valueFieldName: 'population_office_500m',
                crFieldName: 'population_office_500m_conversion_rate',
            },
        ],
    },
    {
        sectionTitle: 'Dân cư xung quanh',
        fields: [
            {
                valueFieldName: 'population_residential_300m',
                crFieldName: 'population_residential_300m_conversion_rate',
            },
            {
                valueFieldName: 'population_residential_500m',
                crFieldName: 'population_residential_500m_conversion_rate',
            },
            {
                valueFieldName: 'population_residential_700m',
                crFieldName: 'population_residential_700m_conversion_rate',
            },
        ],
    },
    {
        sectionTitle: 'Dân cư khác',
        fields: [
            {
                valueFieldName: 'population_student_1000m',
                crFieldName: 'population_student_1000m_conversion_rate',
            },
            {
                valueFieldName: 'population_others',
                crFieldName: 'population_others_conversion_rate',
            },
            {
                valueFieldName: 'population_shopping_mall',
                crFieldName: 'population_shopping_mall_conversion_rate',
            },
        ],
    }
];

// The Roster component matches one of two different routes
// depending on the full pathname
export default class SiteEditScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isCreate: window.location.href.includes('sites/create') || false,
            site: this.props.site || {
                id: parseInt(this.props.match.params.location_id, 10) || '',
                is_site_dev_location: true,
                description: '',
                name: '',
                segment_query: '',
                changed_by: Cookies.get('current_user_id'),
                created_by: Cookies.get('current_user_id'),
                brand: {
                    id: null,
                },
            },
            activeTab: '1',
            labelNames: this.props.labelNames || [],
            actions: [],
            isLoading: false,
            isValidating: false,
            isUploading: false,
            isView: this.props.isView || false,
            segmentUserCount: 0,
            validationError: '',
            isAddNewAction: false,
            selectedPhotos: null,
            alertMessage: [],
            selectedCaptions: {},
            selectedDistrict: null,
            districtList: [],
            showLightBox: false,
            photoIndex: 0,
            customAttributeInfo: [],
            customAttributeData:
            this.props.site && this.props.site.custom_attribute_data
            ? JSON.parse(this.props.site.custom_attribute_data)
            : {},
            };
        this.updateAttr = this.updateAttr.bind(this);
    }
    UNSAFE_componentWillMount() {
        // this.getCustomAttributeInfo(this.props.site.location_type.id);
        if (window.location.href.includes('sites/create')) {
            this.getSiteFieldInfo();
            this.getCurrentUser();
        } else {
            if (this.props.site && this.props.site.location_type) {
                this.getCustomAttributeInfo(this.props.site.location_type.id);
            }
            // If not site is passed, only then should we call the API
            if (!this.props.site) {
                this.getSiteDetail();
            }
        }
    }
    componentDidMount = () => {
        if (this.props.site) {
            this.setState({ site: this.props.site, labelNames: this.props.labelNames, selectedDistrict: this.props.site.district ? {label: this.props.site.district.name, value: this.props.site.district} : null });
        }
    }
    componentDidUpdate(prevProps){
        if (prevProps.site !== this.props.site) {
            this.setState({
                site: this.props.site,
            });
        }

        if (prevProps.labelNames !== this.props.labelNames) {
            this.setState({
                labelNames: this.props.labelNames,
            });
        }
    }
    validateSiteInfoCheck() {
        const { site, labelNames } = this.state;
        const alertMessage = [];
        constants.SITE_REQUIRED_FIELDS.map(requiredField => {
            if (!site[requiredField]) {
                const fieldName = labelNames[requiredField];
                alertMessage.push(`${fieldName} không được để trống`);
            }
        });
        if (alertMessage) {
            this.setState({
                alertMessage,
            });
        } else {
            alert('Everything is good');
        }
    }
    getCurrentUser() {
        api.fetchAPI({
            method: 'get',
            uri: `userme/me`,
            success: (response) => {
                if (response.result) {
                    const currentUser = response.result;
                    const { site } = this.state;

                    if (currentUser.user_brand) {
                        site.brand.id = currentUser.user_brand.brand_id;
                    }
                    
                    this.setState({
                        currentUser,
                        site,
                    }, ()=> {
                        if (site.brand) {
                            this.getLocationTypeByBrand(site.brand.id)
                        }
                    });
                } else {
                    alert('Failed to get user: ' + response.msg);
                }
            },
            error: (error) => {
              console.error(error);
            }
        });
    }
    getSiteFieldInfo() {
        api.fetchAPI({
            method: 'get',
            uri: `location/_info`,
            success: (response) => {
                const labelNames = {}
                response.edit_columns.map(eachColumn => {
                    labelNames[eachColumn.name] = eachColumn.label;
                });
                this.setState({
                    labelNames,
                    isLoading: false,
                });
            },
            error: (error) => {
              console.error(error);
              this.setState({ isLoading: false });
            }
        });
    }
    getSiteDetail() {
        const { site } = this.state;
        this.setState({ isLoading: true });
        api.fetchAPI({
            method: 'get',
            uri: `location/${site.id}`,
            success: (response) => {
                response.result.city && this.getDistrictListByCityId(response.result.city.id)
                this.setState({
                    site: response.result,
                    selectedDistrict: response.result.district ? {label: response.result.district.name, value: response.result.district} : null,
                    labelNames: response.label_columns,
                    isLoading: false,
                    customAttributeData: response.result && response.result.custom_attribute_data ? JSON.parse(response.result.custom_attribute_data) : {},
                }, ()=>{
                    if (response.result.location_type) {
                        this.getCustomAttributeInfo(response.result.location_type.id)
                    }
                });
            },
            error: (error) => {
              console.error(error);
              this.setState({ isLoading: false });
            }
        });
    }
    getLocationTypeByBrand(brand_id) {
        const filterString = `(col:is_active,opr:eq,value:1),(col:brand,opr:rel_o_m,value:${brand_id})`;
        api.fetchAPI({
          method: "get",
          uri: `brand_location_type/?q=(filters:!(${filterString}))`,
          success: response => {
            if (response.result) {
              const brand = response.result[0]
              let newSite = this.state.site
              newSite['location_type'] = brand.location_type
              this.setState({ site: newSite }, ()=>{
                  if (brand.location_type) {
                    this.getCustomAttributeInfo(brand.location_type.id)
                  }
              });
            } else {
              alert("Failed to get user: " + response.msg);
            }
          },
          error: error => {
            console.error(error);
          }
        });
      }
    getCustomAttributeInfo(location_type_id) {
        const { site } = this.state;
        api.fetchAPI({
          method: "get",
          uri: `location_attribute/?q=(filters:!((col:location_type,opr:rel_o_m,value:${location_type_id})))`,
          success: (response) => {
            this.setState({
              customAttributeInfo: response.result,
            });
          },
          error: (error) => {
            console.error(error);
          },
        });
      }
    getDistrictListByCityId = cityId => {
        api.fetchAPI({
          method: "get",
          uri: `district/?q=(filters:!((col:city,opr:rel_o_m,value:${cityId})))`,
          success: response => {
            if (response.result) {
              if (cityId === 29) {
                var i = 0
                var j = 10
                var districts = [];
                var numDistricts = [];
                var sortedNumDistrict = []
                var strDistricts = []
                response.result.forEach(item => {
                  if (item.name?.includes("Quận") && item.name.split(" ").length === 2) {
                    if (item.name?.split(" ")[1] >= 10) {
                      numDistricts[j] = {
                        label: item.name,
                        value: item
                      }
                      j++
                    } else {
                      numDistricts[i] = {
                        label: item.name,
                        value: item
                      }
                      i++
                    }
                  } else if (item.name?.includes("Quận")) {
                    strDistricts.push({
                      label: item.name,
                      value: item
                    });
                  } else {
                    districts.push({
                      label: item.name,
                      value: item
                    });
                  }
                });
                this.setState({districtList: [...numDistricts, ...strDistricts, ...districts]});        
              } else {
                this.setState({districtList: response.result.map(item => {
                    return {
                      label: item.name,
                      value: item
                    };
                  })});
              }
            }
          },
          error: error => {
            console.error(error);
          }
        });
      };
    saveSite(exitAfterSave) {
        const { site, selectedPhotos, selectedCaptions, isCreate } = this.state;
        this.setState({ isLoading: true, alertMessage: [] });

        // Check required fields and data validation
        let alertMessage = [];
        
        if (alertMessage && alertMessage.length > 0) {
            this.setState({
                alertMessage,
            });
        } else {
            // Upload
            api.fetchAPI({
                method: isCreate ? 'post' : 'put',
                uri: isCreate ? 'location/' : `location/${site.id}`,
                body: site,
                success: async (response) => {
                    if (response.result) {
                        // On create, update a few data
                        if (isCreate) {
                            site.id = response.id;
                        }
                        // Upload photos, if any
                        if (selectedPhotos) {
                            alert('Will upload photos, please be patient ^^');
                            await this.uploadImage()
                                .then(() => {
                                    alert('Thông tin đã được lưu thành công.');
                                    if (exitAfterSave) window.location = `/site/${site.id}`;
                                });
                        } else {
                            if (selectedCaptions) {
                                await this.updateImageCaption()
                            }
                            if (exitAfterSave) {
                                alert('Thông tin đã được lưu thành công.');
                                window.location = `/site/${site.id}`;
                            }
                        }
                        this.setState({
                            isUploading: false,
                            isLoading: false,
                        });
                    }
                },
                error: (error) => {
                alert(error.msg);
                this.setState({ isLoading: false });
                },
            });
        }
        this.setState({ isLoading: false });
    }
    async uploadImage() {
        const { site, selectedPhotos, selectedCaptions } = this.state;
        this.setState({ isUploading: true });
        
        const promiseAll = [];
        Object.keys(selectedPhotos).forEach(async (photoAttribute, index) => {

            if (!selectedCaptions[photoAttribute]) {
                selectedCaptions[photoAttribute] = {};
            }

            if (!selectedCaptions[photoAttribute]['caption_text']) {
                selectedCaptions[photoAttribute]['caption_text'] = '';
            }

            const submitData = new FormData();
            submitData.set('user_file', selectedPhotos[photoAttribute]['url']);
            submitData.set('caption_text', selectedCaptions[photoAttribute]['caption_text']);

            promiseAll.push(
                api.fetchAPI({
                    method: 'post',
                    body: submitData,
                    uri: `locationfiles/${site.id}/photo_upload/${photoAttribute}`,
                    success: (response) => {
                        console.log(response);
                    },
                })
            );
        });
        await Promise.all(promiseAll);
    }
    async updateImageCaption() {
        const { site, selectedCaptions } = this.state;
        this.setState({ isUploading: true });
        
        const promiseAll = [];
        Object.keys(selectedCaptions).forEach(async (photoAttribute, index) => {
            const submitData = new FormData();
            submitData.set('caption_text', selectedCaptions[photoAttribute]['caption_text']);

            promiseAll.push(
                api.fetchAPI({
                    method: 'post',
                    body: submitData,
                    uri: `locationfiles/${site.id}/photo_caption_update/${photoAttribute}`,
                    success: (response) => {
                        console.log(response);
                    },
                })
            );
        });
        await Promise.all(promiseAll);
    }
    deleteAttachment(attachment_location_id, imageAttribute) {
        const confirm = window.confirm('Bạn có chắc sẽ xóa ảnh này?');
        if (!confirm) return;

        const { site } = this.state;

        api.fetchAPI({
            method: 'put',
            body: {
                is_active: 0,
            },
            uri: `file_attachment/${attachment_location_id}`,
            success: (response) => {
               if (response.result) {
                    site.photos[imageAttribute] = null;
                    this.setState({ site });
               }
            },
        })
    }
    updateAttr(attribute, value) {
        const { site } = this.state;
        if (value == '') value = null;
        site[attribute] = value;

        if (attribute === 'initial_lease_rate') {
            // Also set final lease rate if the user adjust inital lease rate
            site['lease_rate'] = value;
        }
        if (attribute === 'city') {
            let newSite = this.state.site
            newSite['district'] = null
            newSite['ward'] = null;
            this.setState({selectedDistrict: null, site: newSite})
            this.getDistrictListByCityId(value.id)
        }
        this.setState({ site });
    }
    onPhotoSelected(event, imageAttribute) {
        let { selectedPhotos, selectedCaptions, site } = this.state;
        if (!selectedPhotos) {
            selectedPhotos = {};
        }
        if (!selectedPhotos[imageAttribute]) {
            selectedPhotos[imageAttribute] = {};
        }
        if (!selectedCaptions[imageAttribute]) {
            selectedCaptions[imageAttribute] = {};
        }

        if (!site.photos) {
            site.photos = {};
        }
        if (!site.photos[imageAttribute]) {
            site.photos[imageAttribute] = {};
        }
        if (site.photos[imageAttribute]) {
            site.photos[imageAttribute]['caption_text'] = '';
            site.photos[imageAttribute]['url'] = '';
        }

        selectedPhotos[imageAttribute]['url'] = event.target.files[0];
        selectedCaptions[imageAttribute]['caption_text'] = '';
        this.setState({ selectedPhotos, site });
    }
    onPhotoCaptionChangeSelected(text, imageAttribute) {
        let { selectedCaptions, site } = this.state;
        if (!selectedCaptions) {
            selectedCaptions = {};
        }
        if (!selectedCaptions[imageAttribute]) {
            selectedCaptions[imageAttribute] = {};
        }
        selectedCaptions[imageAttribute]['caption_text'] = text;

        if (!site.photos[imageAttribute]) {
            site.photos[imageAttribute] = {}
        }

        if (!site.photos[imageAttribute]['caption_text']) {
            site.photos[imageAttribute]['caption_text'] = '';
        }
        site.photos[imageAttribute]['caption_text'] = text;

        this.setState({ selectedCaptions, site });
    }
    findSiteLatLng() {
        const r = window.confirm('Dữ liệu lat, lng lấy tự động có thể bị sai, vui lòng kiểm tra lại trên bản đồ và điều chỉnh nếu cần. Bạn có muốn tiếp tục?');
        if (!r) return;
        const { site } = this.state;
        const full_address = `${site.address_number} ${site.street_name}, ${site.ward ? site.ward.name : ""}, ${site.district ? site.district.name : ""}, ${site.district ? site.city.name : ""}`;
        api.fetchAPI({
            method: 'get',
            uri: `location/geocoding/address_to_lat_lng?address=${full_address}`,
            success: (response) => {
                site.latitude = response.result.latitude;
                site.longitude = response.result.longitude;
                this.setState({ site });
            },
            error: (response) => {
                alert('Error: ' + response.msg);
            }
        })
    }
    createNewAction() {
        this.setState({
            isAddNewAction: true,
        });
    }
    toggle(tab) {
        const { activeTab } = this.state;
        if(activeTab !== tab) {
            this.setState({ activeTab: tab });
        }
    }
    onImageClick(imageUrl, imageArray) {
        imageArray.map((url, idx) => {
            if (url === imageUrl) {
                this.setState({
                    showLightBox: true,
                    photoIndex: idx,
                });
            }
        });
    }
    updateCustomAttributeData(attribute, value) {
        const { site, customAttributeData } = this.state;
        customAttributeData[attribute] = value;
        site["custom_attribute_data"] = JSON.stringify(customAttributeData);
        this.setState({ customAttributeData, site });
      }
    render() {
        const {
            site, labelNames, isLoading, isUploading, selectedPhotos,
            isCreate, isView, activeTab,
            siteDevStatuses,
            alertMessage, districtList, selectedDistrict,
            showLightBox, photoIndex, customAttributeData, customAttributeInfo
        } = this.state;
        if (!site) return null;
        if (isLoading) return (
            <div>
                Đang tải...
            </div>
        );
        const { permissions } = site;
        
        // Prepare images array for lightbox display
        let images = [];
        let imageTitles = [];
        let imageCaptions = [];
        if (site.photos) {
            constants.SITE_IMAGE_ATTRIBUTES.map(eachAttribute => {
                const imageAttribute = eachAttribute.key;
                if (site.photos[imageAttribute]) {
                    images.push(site.photos[imageAttribute]['url']);
                    imageTitles.push(eachAttribute.name);
                    imageCaptions.push(site.photos[imageAttribute]['caption_text']);
                }
            });
        }

        return (
            <Container>
                {!isView &&
                    <div>
                        <h1>{isCreate ? 'Tạo mới' : `Chỉnh sửa ${site.name}`}</h1>
                        <div>
                            <Button
                                color={isLoading || isUploading ? "secondary" : "success"}
                                onClick={() => this.saveSite(true)}
                                disabled={isLoading || isUploading}
                            >
                                {isLoading ? 'Đang lưu...' : isUploading ? 'Đang upload hình' : 'Lưu & thoát'}
                            </Button>
                            {' '}
                            {!isCreate &&
                                <Button
                                    color={isLoading || isUploading ? "secondary" : "info"}
                                    onClick={() => this.saveSite(false)}
                                    disabled={isLoading || isUploading}
                                >
                                    {isLoading ? 'Đang lưu...' : isUploading ? 'Đang upload hình' : 'Lưu'}
                                </Button>
                            }
                            {' '}
                            <Button
                                color="warning"
                                onClick={() => this.validateSiteInfoCheck()}
                            >
                                Kiểm tra dữ liệu
                            </Button>
                        </div>
                    </div>
                }
                {(alertMessage && alertMessage.length > 0) &&
                    <Row className="site-edit__error-message-on-save">
                        <Col xs={12}>
                            <Alert color="danger">
                                <h4>Các thông tin còn thiếu:</h4>
                                <ol>
                                    {alertMessage.map(message => <li key={message}>{message}</li>)}
                                </ol>
                            </Alert>
                        </Col>
                    </Row>
                }
                <Nav tabs className="site-edit__tabs">
                    <NavItem>
                        <NavLink
                            className={`site-edit__tabs-nav-link ${activeTab === '1' ? 'active' : ''}`}
                            onClick={() => { this.toggle('1'); }}
                        >
                            Thông tin chung
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={`site-edit__tabs-nav-link ${activeTab === '2' ? 'active' : ''}`}
                            onClick={() => { this.toggle('2'); }}
                        >
                            Hình ảnh
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={`site-edit__tabs-nav-link ${activeTab === '3' ? 'active' : ''}`}
                            onClick={() => { this.toggle('3'); }}
                        >
                            Dân cư xung quanh
                        </NavLink>
                    </NavItem>
                    {site && site.brand && site.brand.brand_code === 'TCH' &&
                        <NavItem>
                            <NavLink
                                className={`site-edit__tabs-nav-link ${activeTab === '4' ? 'active' : ''}`}
                                onClick={() => { this.toggle('4'); }}
                            >
                                Dự báo tài chính
                            </NavLink>
                        </NavItem>
                    }
                    <NavItem>
                        <NavLink
                            className={`site-edit__tabs-nav-link ${activeTab === '5' ? 'active' : ''}`}
                            onClick={() => { this.toggle('5'); }}
                        >
                            Các chỉ số
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={`site-edit__tabs-nav-link ${activeTab === '6' ? 'active' : ''}`}
                            onClick={() => { this.toggle('6'); }}
                        >
                            Lịch sử
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={`site-edit__tabs-nav-link ${activeTab === '7' ? 'active' : ''}`}
                            onClick={() => { this.toggle('7'); }}
                        >
                            Chủ mặt bằng
                        </NavLink>
                    </NavItem>
                </Nav>
                <TabContent activeTab={activeTab}>
                    <TabPane tabId="1">
                        <div className="site-edit__section">
                            <h2 className="site-edit__section-title">Trạng thái</h2>
                            <Row>
                                <Col xs={12} sm={6}>
                                    <SiteDropdownInput
                                        apiUrl='location/site_dev_status'
                                        callback={(attributeName, value) => this.updateAttr(attributeName, value.id)}
                                        valueListCallback={(valueList) => this.setState({ siteDevStatuses: valueList })}
                                        value={siteDevStatuses ? siteDevStatuses.filter(status => status.value === site.site_dev_status) : null}
                                        placeholder="Trạng thái mặt bằng"
                                        site={site}
                                        labels={labelNames}
                                        attributeName="site_dev_status"
                                        disabled={isView}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} sm={6}>
                                    <SiteTextInput
                                        site={site}
                                        labels={labelNames}
                                        callback={this.updateAttr}
                                        attributeName="internal_code"
                                        disabled={isView}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12}>
                                    <SiteTextInput
                                        textArea
                                        site={site}
                                        labels={labelNames}
                                        callback={this.updateAttr}
                                        attributeName="comment_on_site"
                                        disabled={isView}
                                    />
                                </Col>
                            </Row>
                        </div>
                        <div className="site-edit__section">
                            <h2 className="site-edit__section-title">Thông tin mặt bằng</h2>
                            <Row>
                                <Col xs={12} sm={6}>
                                    <div className="site-edit__attribute">
                                        <SiteDropdownInput
                                            apiUrl='site_type/?q=(filters:!((col:is_active,opr:eq,value:1)))'
                                            callback={this.updateAttr}
                                            value={{ label: site.store_site_type ? site.store_site_type.name : '', value: site.store_site_type ? site.store_site_type.id : ''}}
                                            placeholder="Chọn loại mặt bằng"
                                            site={site}
                                            labels={labelNames}
                                            attributeName="store_site_type"
                                            disabled={isView}
                                        />
                                    </div>
                                </Col>
                                <Col xs={12} sm={6}>
                                    <div className="site-edit__attribute">
                                        <SiteDropdownInput
                                            apiUrl='site_position_type/?q=(filters:!((col:is_active,opr:eq,value:1)))'
                                            callback={this.updateAttr}
                                            value={{ label: site.site_position_type ? site.site_position_type.name : '', value: site.site_position_type ? site.site_position_type.id : ''}}
                                            placeholder="Chọn vị trí mặt bằng mặt bằng"
                                            site={site}
                                            labels={labelNames}
                                            attributeName="site_position_type"
                                            disabled={isView}
                                        />
                                    </div>
                                </Col>
                                <Col xs={12} sm={6}>
                                    <div className="site-edit__attribute">
                                        <SiteDropdownInput
                                            apiUrl='store_format/'
                                            callback={this.updateAttr}
                                            value={{ label: site.store_format ? site.store_format.name : '', value: site.store_format ? site.store_format.id : ''}}
                                            placeholder="Chọn loại mặt bằng"
                                            site={site}
                                            labels={labelNames}
                                            attributeName="store_format"
                                            disabled={isView}
                                        />
                                    </div>
                                </Col>
                                <Col xs={12} sm={6}>
                                    <div className="site-edit__attribute">
                                        <SiteDropdownInput
                                            apiUrl='site_surrounding_area_type/'
                                            callback={this.updateAttr}
                                            value={{ label: site.primary_site_surrounding_area_type ? site.primary_site_surrounding_area_type.name : '', value: site.primary_site_surrounding_area_type ? site.primary_site_surrounding_area_type.id : ''}}
                                            placeholder="Chọn loại mặt bằng"
                                            site={site}
                                            labels={labelNames}
                                            attributeName="primary_site_surrounding_area_type"
                                            disabled={isView}
                                        />
                                    </div>
                                </Col>
                                <Col xs={12} sm={6}>
                                    <div className="site-edit__attribute">
                                        <SiteDropdownInput
                                            apiUrl='site_surrounding_area_type/'
                                            callback={this.updateAttr}
                                            value={{ label: site.secondary_site_surrounding_area_type ? site.secondary_site_surrounding_area_type.name : '', value: site.secondary_site_surrounding_area_type ? site.secondary_site_surrounding_area_type.id : ''}}
                                            placeholder="Chọn loại mặt bằng"
                                            site={site}
                                            labels={labelNames}
                                            attributeName="secondary_site_surrounding_area_type"
                                            disabled={isView}
                                        />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12}>
                                    <SiteTextInput
                                        site={site}
                                        labels={labelNames}
                                        callback={this.updateAttr}
                                        attributeName="name"
                                        disabled={isView}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} sm={6}>
                                    <SiteDropdownInput
                                        apiUrl='city/'
                                        callback={this.updateAttr}
                                        value={{ label: site.city ? site.city.name : '', value: site.city ? site.city.id : '' }}
                                        placeholder="Chọn thành phố"
                                        site={site}
                                        labels={labelNames}
                                        attributeName="city"
                                        disabled={isView}
                                    />
                                </Col>
                                <Col xs={12} sm={6}>
                                    {/* <SiteDropdownInput
                                        apiUrl='district/'
                                        callback={this.updateAttr}
                                        value={{ label: site.district ? site.district.name : '', value: site.district ? site.district.id : '' }}
                                        filter={{ field: 'city_id', value: site.city ? site.city.id : null }}
                                        placeholder="Chọn quận, huyện"
                                        site={site}
                                        labels={labelNames}
                                        attributeName="district"
                                        disabled={isView}
                                    /> */}
                                    <label>Quận / Huyện</label>
                                    <Select
                                        placeholder=""
                                        isDisabled={isView}
                                        options={districtList}
                                        value={selectedDistrict}
                                        onChange={selectedOption => {
                                            let newSite = this.state.site
                                            newSite['ward'] = null
                                            newSite['district'] = {name: selectedOption.value.name, id: selectedOption.value.id}
                                            this.setState({selectedDistrict: selectedOption, site: newSite});
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} sm={6} md={2}>
                                    <SiteTextInput
                                        site={site}
                                        labels={labelNames}
                                        callback={this.updateAttr}
                                        attributeName="address_number"
                                        disabled={isView}
                                    />
                                </Col>
                                <Col xs={12} sm={6} md={4}>
                                    <SiteTextInput
                                        site={site}
                                        labels={labelNames}
                                        callback={this.updateAttr}
                                        attributeName="street_name"
                                        disabled={isView}
                                    />
                                </Col>
                                <Col xs={12} sm={6} md={6}>
                                    {/* <SiteTextInput
                                        site={site}
                                        labels={labelNames}
                                        callback={this.updateAttr}
                                        attributeName="ward_name"
                                        disabled={isView}
                                    /> */}
                                    <SiteDropdownInput
                                        apiUrl={`ward/?q=(filters:!((col:district,opr:rel_o_m,value:${
                                            site.district ? site.district.id : null
                                          })))`}
                                        callback={this.updateAttr}
                                        value={{
                                            label: site.ward ? site.ward.name : "",
                                            value: site.ward ? site.ward.id : ""
                                        }}
                                        // filter={{
                                        //     field: "district_id",
                                        //     value: site.district ? site.district.id : ""
                                        // }}
                                        placeholder="Chọn phường, xã"
                                        site={site}
                                        labels={labelNames}
                                        attributeName="ward"
                                        disabled={isView}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} sm={6} md={3}>
                                    <SiteTextInput
                                        site={site}
                                        labels={labelNames}
                                        callback={this.updateAttr}
                                        attributeName="longitude"
                                        disabled={isView}
                                    />
                                </Col>
                                <Col xs={12} sm={6} md={3}>
                                    <SiteTextInput
                                        site={site}
                                        labels={labelNames}
                                        callback={this.updateAttr}
                                        attributeName="latitude"
                                        disabled={isView}
                                    />
                                </Col>
                                {!isView &&
                                    <Col xs={12} md={3}>
                                        <Label>Lấy lat long tự động</Label>
                                        <br />
                                        <Button color="info" onClick={() => this.findSiteLatLng()}>Find Lat Long</Button>
                                    </Col>
                                }
                                <Col xs={12}>
                                    <SiteTextInput
                                        textArea
                                        site={site}
                                        labels={labelNames}
                                        callback={this.updateAttr}
                                        attributeName="description"
                                        disabled={isView}
                                    />
                                </Col>
                            </Row>
                        </div>
                        
                        <div className="site-edit__section">
                            <h2 className="site-edit__section-title">Thông tin mặt bằng</h2>
                            <Row>
                                <Col xs={12} sm={6}>
                                    <SiteTextInput
                                        site={site}
                                        labels={labelNames}
                                        callback={this.updateAttr}
                                        attributeName="total_area"
                                        disabled={isView}
                                    />
                                </Col>
                                <Col xs={12} sm={6}>
                                    <SiteTextInput
                                        site={site}
                                        labels={labelNames}
                                        callback={this.updateAttr}
                                        attributeName="area"
                                        disabled={isView}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} sm={6}>
                                    <SiteTextInput
                                        site={site}
                                        labels={labelNames}
                                        callback={this.updateAttr}
                                        attributeName="floor_count"
                                        disabled={isView}
                                    />
                                </Col>
                                <Col xs={12} sm={6}>
                                    <SiteTextInput
                                        site={site}
                                        labels={labelNames}
                                        callback={this.updateAttr}
                                        attributeName="facade_length"
                                        disabled={isView}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} sm={6}>
                                    <SiteTextInput
                                        site={site}
                                        labels={labelNames}
                                        callback={this.updateAttr}
                                        attributeName="pavement_width"
                                        disabled={isView}
                                    />
                                </Col>
                                <Col xs={12} sm={6}>
                                    <SiteTextInput
                                        site={site}
                                        labels={labelNames}
                                        callback={this.updateAttr}
                                        attributeName="pavement_length"
                                        disabled={isView}
                                    />
                                </Col>
                                <Col xs={12}>
                                    <SiteTextInput
                                        textArea
                                        site={site}
                                        labels={labelNames}
                                        callback={this.updateAttr}
                                        attributeName="pavement_description"
                                        disabled={isView}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} sm={6}>
                                    <SiteDropdownInput
                                        apiUrl='parking_site_type/'
                                        callback={this.updateAttr}
                                        value={{ label: site.parking_site_type ? site.parking_site_type.name : '', value: site.parking_site_type ? site.parking_site_type.id : '' }}
                                        placeholder="Vị trí bãi xe chính"
                                        site={site}
                                        labels={labelNames}
                                        attributeName="parking_site_type"
                                        disabled={isView}
                                    />
                                </Col>
                                <Col xs={12} sm={6}>
                                    <SiteTextInput
                                        site={site}
                                        labels={labelNames}
                                        callback={this.updateAttr}
                                        attributeName="distance_from_parking_to_location"
                                        disabled={isView}
                                    />
                                </Col>
                                <Col xs={12} sm={6}>
                                    <SiteTextInput
                                        site={site}
                                        labels={labelNames}
                                        callback={this.updateAttr}
                                        attributeName="number_of_parking_bikes"
                                        disabled={isView}
                                    />
                                </Col>
                                <Col xs={12} sm={6}>
                                    <SiteTextInput
                                        site={site}
                                        labels={labelNames}
                                        callback={this.updateAttr}
                                        attributeName="number_of_parking_cars"
                                        disabled={isView}
                                    />
                                </Col>
                            </Row>
                        </div>
                        <div className="site-edit__section">
                            <h2 className="site-edit__section-title">Chi phí mặt bằng</h2>
                            <Row>
                                <Col xs={12} sm={6}>
                                    <SiteTextInput
                                        site={site}
                                        labels={labelNames}
                                        callback={this.updateAttr}
                                        attributeName="initial_lease_rate"
                                        isNumeric
                                        disabled={isView}
                                    />
                                </Col>
                                <Col xs={12} sm={6}>
                                    <SiteTextInput
                                        site={site}
                                        labels={labelNames}
                                        callback={this.updateAttr}
                                        attributeName="market_lease_rate"
                                        isNumeric
                                        disabled={isView}
                                    />
                                </Col>
                                <Col xs={12} sm={6}>
                                    <SiteTextInput
                                        site={site}
                                        labels={labelNames}
                                        callback={this.updateAttr}
                                        attributeName="lease_rate"
                                        isNumeric
                                        disabled={isView}
                                        note="Nếu chưa có giá chốt, hãy dùng tạm giá chủ mặt bằng chào"
                                    />
                                </Col>
                                <Col xs={12} sm={6}>
                                    <SiteTextInput
                                        site={site}
                                        labels={labelNames}
                                        callback={this.updateAttr}
                                        attributeName="lease_term_year"
                                        disabled={isView}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} sm={6}>
                                    <SiteTextInput
                                        site={site}
                                        labels={labelNames}
                                        callback={this.updateAttr}
                                        attributeName="increase_rate_year_period"
                                        disabled={isView}
                                    />
                                </Col>
                                <Col xs={12} sm={6}>
                                    <SiteTextInput
                                        site={site}
                                        labels={labelNames}
                                        callback={this.updateAttr}
                                        attributeName="increase_rate_period_note"
                                        disabled={isView}
                                    />
                                </Col>
                                <Col xs={12} sm={6}>
                                    <Label>{labelNames.available_from}</Label>
                                    <DatePicker
                                        selected={site.available_from ? moment(site.available_from, 'YYYY-MM-DD').toDate() : moment().toDate()}
                                        onChange={(date) => this.updateAttr('available_from', moment(date).format('YYYY-MM-DD'))}
                                        dateFormat="yyyy-MM-dd"
                                        disabled={isView}
                                    />
                                </Col>
                                <Col xs={12} sm={6}>
                                    <SiteTextInput
                                        site={site}
                                        labels={labelNames}
                                        callback={this.updateAttr}
                                        attributeName="free_construction_days"
                                        disabled={isView}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} sm={6}>
                                    <SiteTextInput
                                        site={site}
                                        labels={labelNames}
                                        callback={this.updateAttr}
                                        attributeName="contact_phone"
                                        disabled={isView}
                                    />
                                </Col>
                                <Col xs={12} sm={6}>
                                    <SiteTextInput
                                        site={site}
                                        labels={labelNames}
                                        callback={this.updateAttr}
                                        attributeName="contact_name"
                                        disabled={isView}
                                    />
                                </Col>
                            </Row>
                        </div>
                        <div className="site-edit__section">
                            <h2 className="site-edit__section-title">Thông tin bổ sung</h2>
                            <Row>
                                {customAttributeInfo.map((item, index) => {
                                    if (item.type == 'select') {                                        
                                        return (
                                        <Col xs={12} sm={6}>
                                            <br/>
                                            <label>{item.name}</label>
                                            <Select
                                                placeholder=""
                                                isDisabled={isView}
                                                options={CUSTOM_ATTRIBUTE_SELECT_OPTION[item.code_name]}
                                                value={CUSTOM_ATTRIBUTE_SELECT_OPTION[item.code_name].find(object => object.value == customAttributeData[item.code_name])}
                                                onChange={selectedOption => {
                                                    this.updateCustomAttributeData(
                                                        item.code_name,
                                                        selectedOption.value
                                                    )
                                                }}
                                            />
                                        </Col>
                                        )
                                    } else {
                                        return (
                                            <Col xs={12} sm={6}>
                                                {index !== 0 && index !== 1 && <br />}
                                                <Label className="site-attribute__text-input-label">
                                                {item.name}
                                                </Label>
                                                <Input
                                                type={item.type === "note" ? "textarea" : null}
                                                className="site-attribute__text-input-box"
                                                onChange={(e) =>
                                                    this.updateCustomAttributeData(
                                                    item.code_name,
                                                    item.type === "integer"
                                                        ? e.target.value.replace(/\D/g, "")
                                                        : e.target.value
                                                    )
                                                }
                                                value={customAttributeData[item.code_name]}
                                                disabled={isView}
                                                />
                                            </Col>
                                            );
                                    }
                                })}
                            </Row>
                        </div>
                    </TabPane>
                    <TabPane tabId="2">
                        <div className="site-edit__section">
                            <h2 className="site-edit__section-title">Hình ảnh</h2>
                            <Row>
                                {constants.SITE_IMAGE_ATTRIBUTES.map(eachAttribute => {
                                    const imageAttribute = eachAttribute.key;
                                    const imageName = eachAttribute.name;
                                    return (
                                        <Col xs={12} sm={6} md={4} key={imageAttribute}>
                                            <div className="location-photo-item">
                                                <div>
                                                    <FormGroup>
                                                        <h4 className="site-edit__img-name">{labelNames[imageAttribute.key] || imageName}</h4>
                                                        {!isView &&
                                                            <Input type="file" onChange={(event) => this.onPhotoSelected(event, imageAttribute)}>
                                                                Chọn ảnh nha
                                                            </Input>
                                                        }
                                                    </FormGroup>
                                                    {!isView &&
                                                        <FormGroup>
                                                            <Input
                                                                type="text"
                                                                placeholder="Ghi chú"
                                                                value={site && site.photos && site.photos[imageAttribute] ? site.photos[imageAttribute]['caption_text'] : ''}
                                                                onChange={(event) => this.onPhotoCaptionChangeSelected(event.target.value, imageAttribute)}
                                                            />
                                                        </FormGroup>
                                                    }
                                                    {selectedPhotos &&
                                                        <div className="site-edit__img-container">
                                                            {selectedPhotos[imageAttribute] && selectedPhotos[imageAttribute]['url'] &&
                                                                <img className="site-edit__img" src={URL.createObjectURL(selectedPhotos[imageAttribute]['url'])} />
                                                            }
                                                        </div>
                                                    }
                                                </div>
                                                {site.photos &&
                                                    <div className="site-edit__img-container">
                                                        {selectedPhotos && selectedPhotos[imageAttribute] && selectedPhotos[imageAttribute] ?
                                                            null
                                                            :
                                                            <div>
                                                                {site.photos[imageAttribute] && site.photos[imageAttribute]['url'] ?
                                                                    <div className="site-edit__img-inner">
                                                                        <div
                                                                            className="site-edit__img"
                                                                            style={{ backgroundImage: `url(${site.photos[imageAttribute]['url']})` }}
                                                                            onClick={() => this.onImageClick(site.photos[imageAttribute]['url'], images)}
                                                                        />
                                                                        {!isView &&
                                                                            <Button
                                                                                className="site-edit__img-delete-button"
                                                                                size="sm"
                                                                                color="danger"
                                                                                onClick={() => this.deleteAttachment(site.photos[imageAttribute]['attachment_location_id'], imageAttribute)}
                                                                            >
                                                                                Xóa
                                                                            </Button>
                                                                        }
                                                                    </div>
                                                                    :
                                                                    <div className="site-edit__img" style={{ backgroundImage: `url(${PhotoPlaceholder})` }} />
                                                                }
                                                            </div>
                                                        }
                                                    </div>
                                                }
                                                {isView &&
                                                    <p className="site-edit__img-caption">{site && site.photos && site.photos[imageAttribute] ? site.photos[imageAttribute]['caption_text'] : ''}</p>
                                                }
                                            </div>
                                        </Col>
                                    );
                                })}
                            </Row>
                        </div>
                    </TabPane>
                    <TabPane tabId="3">
                        <div className="site-edit__section">
                            <h2 className="site-edit__section-title">Khả năng tiếp cận</h2>
                            <Row>
                                <Col xs={12} sm={6} md={4}>
                                    <SiteTextInput
                                        site={site}
                                        labels={labelNames}
                                        callback={this.updateAttr}
                                        attributeName="visibility_from_distance_km"
                                        disabled={isView}
                                        isNumeric
                                    />
                                </Col>
                                <Col xs={12} sm={6} md={4}>
                                    <SiteTextInput
                                        site={site}
                                        labels={labelNames}
                                        callback={this.updateAttr}
                                        attributeName="main_street_width"
                                        disabled={isView}
                                        isNumeric
                                    />
                                </Col>
                                <Col xs={12} sm={6} md={4}>
                                    <SiteTextInput
                                        site={site}
                                        labels={labelNames}
                                        callback={this.updateAttr}
                                        attributeName="main_street_traffic"
                                        disabled={isView}
                                        isNumeric
                                    />
                                </Col>
                            </Row>
                        </div>
                        {POPULATION_FIELDS.map(populationArea => 
                            <div className="site-edit__section" key={populationArea.sectionTitle}>
                                <h2 className="site-edit__section-title">{populationArea.sectionTitle}</h2>
                                {populationArea.fields.map(eachRadius =>
                                    <Row key={eachRadius.valueFieldName}>
                                        <Col xs={12} sm={6} md={4}>
                                            <SiteTextInput
                                                site={site}
                                                labels={labelNames}
                                                callback={this.updateAttr}
                                                attributeName={eachRadius.valueFieldName}
                                                disabled={isView}
                                                isNumeric
                                            />
                                        </Col>
                                        <Col xs={12} sm={6} md={4}>
                                            <SiteTextInput
                                                site={site}
                                                labels={labelNames}
                                                callback={this.updateAttr}
                                                attributeName={eachRadius.crFieldName}
                                                disabled={isView}
                                            />
                                        </Col>
                                        <Col xs={12} sm={6} md={4}>
                                            <Label>Có thể target</Label>
                                            <Input
                                                disabled
                                                value={site[eachRadius.valueFieldName] * site[eachRadius.crFieldName]}
                                            />
                                        </Col>
                                    </Row>
                                )}
                            </div>
                        )}
                    </TabPane>
                    {site && site.brand && site.brand.brand_code === 'TCH' &&
                        <TabPane tabId="4">
                            <div className="site-edit__metrics">
                            {permissions && permissions?.includes('can_site_financial_projection_metrics') ?
                                <div>
                                    {!isCreate ?
                                        null
                                        :
                                        <Col xs={12}>
                                            <br />
                                            <br />
                                            <h5>Bạn phải tạo xong mới dùng được chức năng này</h5>
                                        </Col>
                                    }
                                </div>
                                :
                                <Row>
                                    <Col xs={12}>
                                        <h5>Bạn không có quyền này</h5>
                                    </Col>
                                </Row>
                            }
                            </div>
                        </TabPane>
                    }
                    <TabPane tabId="5">
                        <div className="site-edit__metrics">
                            {permissions && permissions?.includes('can_get_location_time_series_metrics') ?
                                <LocationMetricsView
                                    locationId={site.id}
                                    site={site}
                                />
                                :
                                <Row>
                                    <Col xs={12}>
                                        <h5>Bạn không có quyền này</h5>
                                    </Col>
                                </Row>
                            }
                        </div>
                    </TabPane>
                    <TabPane tabId="6">
                        <div className="site-edit__section">
                            <h2 className="site-edit__section-title">Thay đổi trạng thái</h2>
                            <p>Coming soon...</p>
                            {/* <SiteStatusChangeLog
                                site={site}
                            /> */}
                        </div>
                    </TabPane>
                    <TabPane tabId="7">
                        <div className="site-edit__metrics">
                            <LocationContactView
                                locationId={site.id}
                            />
                        </div>
                    </TabPane>
                </TabContent>
                {showLightBox &&
                    <Lightbox
                        mainSrc={images[photoIndex]}
                        nextSrc={images[(photoIndex + 1) % images.length]}
                        prevSrc={images[((photoIndex + images.length) - 1) % images.length]}
                        onCloseRequest={() => this.setState({ showLightBox: false })}
                        onMovePrevRequest={() =>
                            this.setState({
                                photoIndex: ((photoIndex + images.length) - 1) % images.length,
                            })
                        }
                        onMoveNextRequest={() =>
                            this.setState({
                                photoIndex: (photoIndex + 1) % images.length,
                            })
                        }
                        imageTitle={imageTitles[photoIndex]}
                        imageCaption={imageCaptions[photoIndex]}
                    />
                }
            </Container>
        );
    }
}

const CUSTOM_ATTRIBUTE_SELECT_OPTION = {
    "car_parking": [
        {
            label: "Không có",
            value: "Không có"
        },
        {
            label: "Đậu xe hơi miễn phí",
            value: "Đậu xe hơi miễn phí"
        },
        {
            label: "Đậu xe hơi có tính phí",
            value: "Đậu xe hơi có tính phí"
        }
    ],
    "main_road_ways": [
        {
            label: "Đường 1 chiều",
            value: "Đường 1 chiều"
        },
        {
            label: "Đường 2 chiều",
            value: "Đường 2 chiều"
        }
    ],
    "is_flooded_with_tide": [
        {
            label: "Có",
            value: "Có"
        },
        {
            label: "Không",
            value: "Không"
        }
    ],
    "is_flooded_with_rain": [
        {
            label: "Có",
            value: "Có"
        },
        {
            label: "Không",
            value: "Không"
        }
    ],
    "external_environmental_factors": [
        {
            label: "Lô cốt",
            value: "Lô cốt"
        },
        {
            label: "Công trình đang xây dựng",
            value: "Công trình đang xây dựng"
        },
        {
            label: "Đường 2 chiều đổi thành 1 chiều",
            value: "Đường 2 chiều đổi thành 1 chiều"
        },
        {
            label: "Có cầu vượt",
            value: "Có cầu vượt"
        }
    ],
    "primary_customer_group": [
        {
            label: "Sinh viên",
            value: "Sinh viên"
        },
        {
            label: "Nhân viên văn phòng",
            value: "Nhân viên văn phòng"
        },
        {
            label: "Freelancer",
            value: "Freelancer"
        },
        {
            label: "Dân cư xung quanh",
            value: "Dân cư xung quanh"
        },
        {
            label: "Khách du lịch",
            value: "Khách du lịch"
        },
        {
            label: "Nhân viên nhà nước",
            value: "Nhân viên nhà nước"
        }
    ],
    "secondary_customer_group": [
        {
            label: "Sinh viên",
            value: "Sinh viên"
        },
        {
            label: "Nhân viên văn phòng",
            value: "Nhân viên văn phòng"
        },
        {
            label: "Freelancer",
            value: "Freelancer"
        },
        {
            label: "Dân cư xung quanh",
            value: "Dân cư xung quanh"
        },
        {
            label: "Khách du lịch",
            value: "Khách du lịch"
        },
        {
            label: "Nhân viên nhà nước",
            value: "Nhân viên nhà nước"
        }
    ],
}
